import { ErrorBoundary } from 'react-error-boundary';
import { useCallback } from 'react';
import { Fallback } from './fallback';

export const AppErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const handleError = useCallback((error: Error) => {
    // eslint-disable-next-line no-console
    console.error(error);
  }, []);

  return (
    <ErrorBoundary FallbackComponent={Fallback} onError={handleError}>
      {children}
    </ErrorBoundary>
  );
};
